import singapore from "./module/singapore";
import malaysia from "./module/malaysia";

export default {
  zh: {
    ...singapore.zh,
    malaysia: malaysia.zh,
  },
  en: {
    ...singapore.en,
    malaysia: malaysia.en,
  },
};
